/*
 * Couleur 閲覧履歴（Recently Viewed / 旧カラーミー CHECKED ITEMS 相当）
 * Shopify 標準機能外 → localStorage ベース。
 * - PDP: #pdp-rv-data(JSON) の商品を履歴に記録（最大12・重複は最新へ繰り上げ）。
 * - 描画先: [data-recently-viewed] コンテナ（ホーム sec8 / マイページ Browse History 等）に .pcell カードを生成。
 *   履歴が空のときは親 [data-rv-section] を hidden（セクションごと非表示）。
 * 商品カードは couleur-home.css の .pgrid/.pcell/.pimg/.pmeta を流用（体裁を新着グリッドと統一）。
 */
(function () {
  'use strict';
  var KEY = 'couleur-recently-viewed';
  var MAX = 12;

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : String(s)); return d.innerHTML; }

  function record(p) {
    if (!p || !p.handle) return;
    var a = read().filter(function (x) { return x.handle !== p.handle; });
    a.unshift(p);
    if (a.length > MAX) a = a.slice(0, MAX);
    write(a);
  }

  function card(p) {
    var price = p.inquiry ? ((window.CouleurI18n && window.CouleurI18n.inquiry_price_html) || 'Inquiry &rarr;') : esc(p.price);
    return '<a class="pcell" href="' + esc(p.url) + '">' +
      '<div class="pimg">' + (p.img ? '<img loading="lazy" src="' + esc(p.img) + '" alt="">' : '') + '</div>' +
      '<div class="pmeta">' +
        '<span class="pbrand">' + esc(p.vendor) + '</span>' +
        '<span class="pname">' + esc(p.title) + '</span>' +
        '<span class="pprice">' + price + '</span>' +
      '</div></a>';
  }

  function render(el, excludeHandle) {
    var items = read().filter(function (x) { return x.handle !== excludeHandle; });
    var section = el.closest ? el.closest('[data-rv-section]') : null;
    if (!items.length) { if (section) section.hidden = true; return; }
    el.innerHTML = items.map(card).join('');
    if (section) section.hidden = false;
  }

  function init() {
    var current = null;
    var data = document.getElementById('pdp-rv-data');
    if (data) { try { current = JSON.parse(data.textContent); } catch (e) {} }
    if (current) record(current);
    var targets = document.querySelectorAll('[data-recently-viewed]');
    for (var i = 0; i < targets.length; i++) render(targets[i], current ? current.handle : null);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
